/**
 * @param {Blob} fileBlob
 */
export const openFileInNewWindow = (fileBlob) => {
  const fileURL = URL.createObjectURL(fileBlob);
  window.open(fileURL, '_blank');
}
